import Input from '../../../components/Input'
import Checkbox from '../../../components/Checkbox'
import Link from '../../../components/Link'
import Card from '../../../components/Card'
import React from 'react'
import { Company } from '../../../types/Subscription'
import { useTranslation } from 'react-i18next'

type CompanyDataFormProps = {
    data: Partial<Company>
    changeData: (data: Partial<Company>) => void
    showAGBandDisclaimer?: boolean
}

const CompanyDataForm: React.FC<CompanyDataFormProps> = ({
    data,
    changeData,
    showAGBandDisclaimer = true,
}) => {
    const { t } = useTranslation(['settings'])

    return (
        <Card title={t('subscription.companyInformation')} classes={'zr-my-6'}>
            <div className={'zr-row'}>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.companyName')}
                        property={'company'}
                        value={data.company ?? ''}
                        onChange={(_, value) => changeData({ company: value })}
                    />
                </div>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.firstName')}
                        property={'firstname'}
                        value={data.firstname ?? ''}
                        onChange={(_, value) =>
                            changeData({ firstname: value })
                        }
                    />
                </div>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.lastName')}
                        property={'lastname'}
                        value={data.lastname ?? ''}
                        onChange={(_, value) => changeData({ lastname: value })}
                    />
                </div>
            </div>
            <div className={'zr-row'}>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.streetNr')}
                        property={'street'}
                        value={data.street ?? ''}
                        onChange={(_, value) => changeData({ street: value })}
                    />
                </div>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.postalCode')}
                        property={'zipcode'}
                        value={data.zipcode ?? ''}
                        onChange={(_, value) => changeData({ zipcode: value })}
                    />
                </div>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.city')}
                        property={'city'}
                        value={data.city ?? ''}
                        onChange={(_, value) => changeData({ city: value })}
                    />
                </div>
            </div>
            <div className={'zr-row'}>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.additionalAddress')}
                        property={'additional'}
                        value={data.additional ?? ''}
                        onChange={(_, value) =>
                            changeData({ additional: value })
                        }
                    />
                </div>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={'USt-ID (optional))'}
                        property={'ust'}
                        value={data.ust ?? ''}
                        onChange={(_, value) => changeData({ ust: value })}
                    />
                </div>
                <div className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t('subscription.telephone')}
                        property={'phone'}
                        value={data.phone ?? ''}
                        onChange={(_, value) => changeData({ phone: value })}
                    />
                </div>
            </div>
            {showAGBandDisclaimer && (
                <div className={'zr-row'}>
                    <div
                        className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}
                    >
                        <Checkbox
                            property={'disclaimer'}
                            value={data.disclaimer ?? false}
                            label={
                                <>
                                    {t('subscription.acceptThe')}{' '}
                                    <Link
                                        target={'_blank'}
                                        url={
                                            'https://jtl.medienagentur-dresden.net/agb/'
                                        }
                                    >
                                        {t('subscription.generalTerms')}
                                    </Link>
                                </>
                            }
                            onChange={(_, value) =>
                                changeData({ disclaimer: value })
                            }
                        />
                    </div>
                    <div
                        className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}
                    >
                        <Checkbox
                            property={'agb'}
                            value={data.agb ?? false}
                            label={
                                <>
                                    {t('subscription.acceptThe')}{' '}
                                    <Link
                                        target={'_blank'}
                                        url={
                                            'https://medienagentur-dresden.net/datenschutz/'
                                        }
                                    >
                                        {t('subscription.privacyPolicy')}
                                    </Link>
                                </>
                            }
                            onChange={(_, value) => changeData({ agb: value })}
                        />
                    </div>
                    <div
                        className={'zr-col-12 zr-col-md-6 zr-col-xl-4 zr-my-3'}
                    ></div>
                </div>
            )}
        </Card>
    )
}

export default CompanyDataForm
